import { CircularProgress } from '@mui/material';
import styled from '@emotion/styled';

import { t } from '@lingui/macro';
import { Button } from 'components/button/Button';

type AuthButtonProps = {
  isLoading?: boolean;
  hasAuthLink?: boolean;
  buttonText?: string;
  onSubmit?: () => void;
  margin?: number;
  disabled?: boolean;
};

export const AuthButton = ({
  isLoading = false,
  hasAuthLink = false,
  buttonText = t`Log in`,
  onSubmit,
  margin = 16,
  disabled = false,
}: AuthButtonProps) => {
  return (
    <ButtonContainer margin={margin} center={isLoading} hasAuthLink={hasAuthLink}>
      {isLoading ? (
        <CircularProgress />
      ) : (
        <Button
          size="lg"
          disabled={disabled}
          variant="primary"
          color="primary"
          type="submit"
          onClick={onSubmit}
        >
          {buttonText}
        </Button>
      )}
    </ButtonContainer>
  );
};

const ButtonContainer = styled.div<{ center: boolean; hasAuthLink: boolean; margin: number }>`
  margin: ${p => p.margin}px 24px;
  ${p => (p.hasAuthLink ? 'margin-bottom: 12px;' : '')}
  display: flex;
  flex-direction: column;
  gap: 16px;
  ${p => (p.center ? 'align-items: center' : '')};
`;
